import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRows } from '../lib/api';
import { createJob, createOpportunity } from '../lib/create';
import { contactName } from '../lib/format';
import { Btn, Field, Modal } from '../ui/kit';

/** "+ New": an opportunity and its first job (one job per scope). */
export function NewOpportunity({ onClose, opportunityId }: { onClose: () => void; opportunityId?: string }) {
  const nav = useNavigate();
  const types = useRows('job_type', { order: ['name'] });
  const contacts = useRows('contact', { order: ['last_name', 'company'] });
  const [name, setName] = useState('');
  const [scope, setScope] = useState('');
  const [typeId, setTypeId] = useState('');
  const [contactId, setContactId] = useState('');
  const [busy, setBusy] = useState(false);
  const ready = (opportunityId || name.trim()) && scope.trim();

  const save = async () => {
    if (!ready || busy) return;
    setBusy(true);
    try {
      const oppId = opportunityId ?? (await createOpportunity(name.trim(), contactId || null)).id;
      const job = await createJob(oppId, scope.trim(), typeId || null);
      onClose();
      nav(`/jobs/${job.id}?tab=setup`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal title={opportunityId ? 'New job on this opportunity' : 'New opportunity'} onClose={onClose}>
      <div className="form">
        {!opportunityId && (
          <>
            <Field label="Opportunity" wide>
              <input type="text" autoFocus value={name} onChange={(e) => setName(e.target.value)} />
            </Field>
            <Field label="Primary contact">
              <select value={contactId} onChange={(e) => setContactId(e.target.value)}>
                <option value="">None yet</option>
                {contacts.rows.map((c) => (
                  <option key={c.id} value={c.id}>
                    {contactName(c)}
                  </option>
                ))}
              </select>
            </Field>
          </>
        )}
        <Field label="Scope (one job per scope)">
          <input type="text" value={scope} onChange={(e) => setScope(e.target.value)} />
        </Field>
        <Field label="Job type">
          <select value={typeId} onChange={(e) => setTypeId(e.target.value)}>
            <option value="">Pick later</option>
            {types.rows.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </select>
        </Field>
      </div>
      <p className="muted" style={{ margin: '10px 0' }}>
        The job type decides which standards the job pulls in. It opens on Job setup.
      </p>
      <Btn primary disabled={!ready || busy} onClick={() => void save()}>
        Create
      </Btn>
    </Modal>
  );
}
